import Api from './index';

const createEvent = async (type: string, data: any) => {
  Api.createTelemetryEvent({ payload: { type, data } });
};

export { createEvent };
